/** India Standard Time — use for all admin UI date display */
export const APP_TIMEZONE = "Asia/Kolkata";

function toDate(value) {
  if (value == null || value === "") return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

/**
 * Default display: `28 Oct 5:30 PM` (IST)
 */
export function dateFormat(value) {
  const date = toDate(value);
  if (!date) return "—";

  const day = date.toLocaleString("en-IN", {
    day: "numeric",
    timeZone: APP_TIMEZONE,
  });
  const month = date.toLocaleString("en-IN", {
    month: "short",
    timeZone: APP_TIMEZONE,
  });
  const time = date
    .toLocaleString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: APP_TIMEZONE,
    })
    .replace(/\s/g, " ")
    .replace(/am/i, "AM")
    .replace(/pm/i, "PM");

  return `${day} ${month} ${time}`;
}

/**
 * With year: `28 Oct 2026 5:30 PM` (IST)
 */
export function dateFormatGame(value) {
  const date = toDate(value);
  if (!date) return "—";

  const day = date.toLocaleString("en-IN", {
    day: "numeric",
    timeZone: APP_TIMEZONE,
  });
  const month = date.toLocaleString("en-IN", {
    month: "short",
    timeZone: APP_TIMEZONE,
  });
  const year = date.toLocaleString("en-IN", {
    year: "numeric",
    timeZone: APP_TIMEZONE,
  });
  const time = date
    .toLocaleString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: APP_TIMEZONE,
    })
    .replace(/\s/g, " ")
    .replace(/am/i, "AM")
    .replace(/pm/i, "PM");

  return `${day} ${month} ${year} ${time}`;
}

/** Date only: `28-10-2026` (IST) */
export function dateOnly(value) {
  const date = toDate(value);
  if (!date) return "—";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: APP_TIMEZONE,
  });
}

/** Alias used by some agent dashboards */
export const dateFormat1 = dateFormat;

/** Alias */
export const formatIST = dateFormat;

export default dateFormat;
